export default function localStorageDB() {
  const dbs={};
  const storeName ="store";

  function databaseExists(dbname, callback) {
      const req = indexedDB.open(dbname,1);
      let existed = true;
      req.onsuccess = function () {
          let db = this.result;
          if (!existed || !db.objectStoreNames.contains(storeName)){
            db.close();
            indexedDB.deleteDatabase(dbname);
            db = null;
          }
          callback(existed,db);
      }
      req.onupgradeneeded = function () {
          existed = false;
      }
  }
  function openDB(_dbname){
    let dbname = "flexDB";
    if(_dbname) dbname = dbname + "_" + _dbname;

    return new Promise((resolve,reject)=>{
      if(dbs[dbname]) return resolve(dbs[dbname]);
      databaseExists(dbname,(existed,db)=>{
        if(existed){
          dbs[dbname] = db;
          return resolve(dbs[dbname]);
        }
        const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        if (!indexedDB) {
          console.error('indexDB not supported');
          reject('indexDB not supported')
          return;
        }
        const request = indexedDB.open(dbname, 1);
        request.onsuccess = function(evt) {
          db = this.result;
        };
        request.onerror = function(event) {
          console.error('indexedDB request error',event);
          reject('indexedDB request error')
        };
        //upgrade db
        request.onupgradeneeded = function(event) {
          db = null;
          const store = event.target.result.createObjectStore(storeName, {
            keyPath: 'k'
          });
          store.transaction.oncomplete = function (e){
            db = e.target.db;
            dbs[dbname] = db;
            resolve(db);
          };
          store.transaction.onerror = function (e){
            console.error('indexedDB request error',e);
            reject('indexedDB request error')
          };
        };
      })
      
    })
  }
  function getValue(key, callback,dbname=undefined) {
    return new Promise((resolve)=>{
      openDB(dbname).then(db=>{
        let txn =db.transaction(storeName)
        txn.onerror = function(event){
          console.error("Can't get item",event);
          if(callback) callback("Can't set item");
          resolve({error:"Can't set item"})
        }
        const objectStore = txn.objectStore(storeName);
        const objectStoreRequest = objectStore.get(key);
        objectStoreRequest.onsuccess = function(event) {
          //console.log("get value",key);
          let result = (event.target.result && event.target.result.v) || null;
          if(callback) callback(null,result);
          resolve(result)
        };

      }).catch(e=>{
        if(callback){
          callback(e);
        } 
        resolve({error:e})
      })
    })
  }
  function setValue(k, v, callback,dbname=undefined) {
    return new Promise((resolve)=>{
      openDB(dbname).then(db=>{
        let txn = db.transaction(storeName, 'readwrite'); 
        txn.oncomplete = function(event) {
          if(callback) callback();
          resolve();
        }
        txn.onerror = function(event){
          console.error("Can't set item",event);
          if(callback) callback("Can't set item");
          resolve({error:"Can't set item"})
        }
        txn.objectStore(storeName).put({
          k,v
        });
        txn.commit();
      }).catch(e=>{
        if(callback){
          callback(e);
        } 
        resolve({error:e})
      })
    })
  }
  function removeValue(k,callback,dbname=undefined){
    return new Promise((resolve)=>{
      openDB(dbname).then(db=>{
        let txn = db.transaction(storeName, 'readwrite'); 
        txn.oncomplete = function(event) {
          if(callback) callback();
          resolve();
        }
        txn.onerror = function(event){
          console.error("Can't remove item",event);
          if(callback) callback("Can't remove item");
          resolve({error:"Can't remove item"});
        }
        txn.objectStore(storeName).delete(k);
        txn.commit();
      }).catch(e=>{
        if(callback){
          callback(e);
        } 
        resolve({error:e})
      })
    })
  }
  function clearStore(dbname,callback){
    return new Promise((resolve)=>{
      openDB(dbname).then(db=>{
        let txn = db.transaction(storeName, 'readwrite'); 
        txn.oncomplete = function(event) {
          //handle transaction complete
        }
        txn.onerror = function(event){
          console.error("Can't clear store",event);
          if(callback) callback("Can't clear store");
          resolve({error:"Can't clear store"});
        }
        const objectStore = txn.objectStore(storeName);
        const objectStoreRequest = objectStore.clear();
        objectStoreRequest.onsuccess = () => {
          if(callback) callback();
          resolve();
        };
      }).catch(e=>{
        if(callback){
          callback(e);
        } 
        resolve({error:e})
      })
    })

  }
  function deleteDB(_dbname){
    let dbname = "flexDB";
    if(_dbname) dbname = dbname + "_" + _dbname;

    if(dbs[dbname]) dbs[dbname].close()
    delete dbs[dbname];
    indexedDB.deleteDatabase(dbname);
  }

  return {
    getItem: getValue,
    removeItem: removeValue,
    setItem: setValue,
    deleteDB,
    clearStore
  }
}